import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

function authHeaders() {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export interface CrmContactTask {
  id: number;
  contactId: number;
  text: string;
  done: boolean;
  sortOrder: number;
  createdAt?: string;
}

export async function fetchCrmContactTasks(contactId: number, sectorId: number): Promise<CrmContactTask[]> {
  const { data } = await axios.get<CrmContactTask[]>(
    `${API_URL}/CrmContactTasks/contact/${contactId}`,
    { params: { sectorId }, headers: { Accept: 'application/json', ...authHeaders() } }
  );
  return Array.isArray(data) ? data : [];
}

export async function createCrmContactTask(contactId: number, sectorId: number, text: string): Promise<CrmContactTask> {
  const { data } = await axios.post<CrmContactTask>(
    `${API_URL}/CrmContactTasks`,
    { contactId, sectorId, text },
    { headers: { 'Content-Type': 'application/json', Accept: 'application/json', ...authHeaders() } }
  );
  return data;
}

export async function patchCrmContactTask(
  id: number,
  sectorId: number,
  patch: { text?: string; done?: boolean }
): Promise<CrmContactTask> {
  const { data } = await axios.patch<CrmContactTask>(`${API_URL}/CrmContactTasks/${id}`, patch, {
    params: { sectorId },
    headers: { 'Content-Type': 'application/json', Accept: 'application/json', ...authHeaders() }
  });
  return data;
}

export async function deleteCrmContactTask(id: number, sectorId: number): Promise<void> {
  await axios.delete(`${API_URL}/CrmContactTasks/${id}`, {
    params: { sectorId },
    headers: { ...authHeaders() }
  });
}
